import React, { useState, useEffect } from 'react';
import { Checkbox, Space } from 'antd';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';
import {
  ColumnSettingsContainer,
  ColumnCheckboxItem,
  ResetButton
} from '../JobList/styledComponents';

export const BILLING_ADMIN_DEFAULT_COLUMNS = {
  jobNumber: true,
  author: true,
  primaryCarePhysician: false,
  patientName: true,
  facilityName: true,
  assignedBillers: false,
  claimedBiller: false,
  workType: false,
  dictationTemplate: false,
  currentAssignee: false,
  status: true,
  billStatus: true,
  effectiveDate: true,
  submittedTime: true,
  emrSubmissionTime: false,
  submissionToReviewerLevel1Time: false,
  rejectedByReviewerTime: false,
  billedTime: false,
  ageInQueue: false,
  admissionDate: false,
  mrn: false,
  dischargeDate: false,
  actions: true
};

const columnConfig = [
  // Default-on columns first
  { key: 'jobNumber', label: 'Job #', mandatory: true },
  { key: 'author', label: 'Doctor', mandatory: false },
  { key: 'patientName', label: 'Patient', mandatory: false },
  { key: 'facilityName', label: 'Facility', mandatory: false },
  { key: 'status', label: 'Status', mandatory: false },
  { key: 'billStatus', label: 'Bill Status', mandatory: false },
  { key: 'effectiveDate', label: 'Encounter Date', mandatory: false },
  { key: 'submittedTime', label: 'Submitted Time', mandatory: false },
  // Default-off columns
  { key: 'primaryCarePhysician', label: 'Primary Care Physician', mandatory: false },
  { key: 'assignedBillers', label: 'Assigned Biller', mandatory: false },
  { key: 'claimedBiller', label: 'Claimed Biller', mandatory: false },
  { key: 'workType', label: 'Work Type', mandatory: false },
  { key: 'dictationTemplate', label: 'Dictation Template', mandatory: false },
  { key: 'currentAssignee', label: 'Current Assignee', mandatory: false },
  { key: 'emrSubmissionTime', label: 'EMR Submission Time', mandatory: false },
  { key: 'submissionToReviewerLevel1Time', label: 'Submission Time to Reviewer', mandatory: false },
  { key: 'rejectedByReviewerTime', label: 'Reviewer Rejected Time', mandatory: false },
  { key: 'billedTime', label: 'Billed Time', mandatory: false },
  { key: 'ageInQueue', label: 'Age in Queue', mandatory: false },
  { key: 'admissionDate', label: 'Admission Date', mandatory: false },
  { key: 'mrn', label: 'MRN', mandatory: false },
  { key: 'dischargeDate', label: 'Discharge Date', mandatory: false }
];

const BillingAdminColumnSettingsModal = ({
  visible,
  onCancel,
  onSave,
  visibleColumns
}) => {
  const [tempColumns, setTempColumns] = useState(visibleColumns);

  useEffect(() => {
    setTempColumns(visibleColumns);
  }, [visibleColumns]);

  const handleToggle = key => {
    const column = columnConfig.find(c => c.key === key);
    if (!column?.mandatory) {
      setTempColumns({ ...tempColumns, [key]: !tempColumns[key] });
    }
  };

  const handleCancel = () => {
    setTempColumns(visibleColumns);
    onCancel();
  };

  const handleSave = () => {
    onSave(tempColumns);
    onCancel();
  };

  const handleReset = () => {
    setTempColumns({ ...BILLING_ADMIN_DEFAULT_COLUMNS });
  };

  return (
    <ConfirmationModal
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSave}
      header='Customize Columns'
      confirmation={true}
      antdModalProps={{ centered: true, width: 450, closable: false }}
    >
      {/* Kept above the scrollable list so it's reachable without scrolling */}
      <ResetButton onClick={handleReset}>Reset to Default</ResetButton>
      <ColumnSettingsContainer>
        <Space direction='vertical' size='middle' style={{ width: '100%' }}>
          {columnConfig.map(column => (
            <ColumnCheckboxItem key={column.key}>
              <Checkbox
                checked={tempColumns[column.key]}
                onChange={() => handleToggle(column.key)}
                disabled={column.mandatory}
              >
                {column.label}
                {column.mandatory && (
                  <span style={{ color: '#999' }}> (Required)</span>
                )}
              </Checkbox>
            </ColumnCheckboxItem>
          ))}
        </Space>
      </ColumnSettingsContainer>
    </ConfirmationModal>
  );
};

export default BillingAdminColumnSettingsModal;
